import { render, staticRenderFns } from "./class-info-list.vue?vue&type=template&id=3234e866&"
import script from "./class-info-list.vue?vue&type=script&lang=js&"
export * from "./class-info-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports